import {AppFunction} from "../misc/types";
import View from "../framework/view";
import FakebookView from "../views/fakebook";

export class FakebookFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new FakebookView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/fakebook`;
    }

}
